import { getAppConfigApi } from '../api';
import { AppEnvType, IAppConfig } from '../model';
import extend from 'extend2';
import { md5, strToJson } from './utils';
import { getNeedManageSites, getSiteDomain, isMultiManageSite } from '.';
import { wrapRequestArea } from './http/lib';
import { getConfig } from '../config';

const DEV_ENV_TOKEN =
  process.env.REACT_APP_CONFIG_TOKEN ||
  (process.env.REACT_APP_TYPE === 'support'
    ? 'b2f48c74582c1748013fe7ed34a4a4ca'
    : '66b887636607b37cba5b977c5aeb6c33'); // it's safe

const getLocalConfig = () => {
  let runTimeConfig = {};
  try {
    // eslint-disable-next-line
    runTimeConfig = require(`../env.${process.env.NODE_ENV}.json`);
  } catch (error) {}
  /*eslint-disable*/
  const defaultConfig = require(`../config/config.default.ts`).default;
  return {
    runTimeConfig,
    defaultConfig,
  };
};

const verifySign = (sign: string, remoteHostname: string) => {
  return sign === md5(remoteHostname);
};

const getSign = (env?: AppEnvType) => {
  return env === AppEnvType.Development
    ? DEV_ENV_TOKEN
    : md5(location.hostname);
};

export const getRemoteAppConfig = async (env?: AppEnvType) => {
  const sign = getSign(env);
  const appConfig = await getAppConfigApi(sign);
  if (!appConfig) {
    return null;
  }
  if (!verifySign(sign, appConfig?.Domain)) {
    return null;
  }

  const remoteConfig = strToJson<IAppConfig>(appConfig.JsonConfig);
  const local = getLocalConfig();
  const config: IAppConfig = extend(
    true,
    {},
    local.defaultConfig,
    local.runTimeConfig,
    remoteConfig
  );
  if (!config.consoleURL || !config.userURL) {
    return null;
  }
  return config;
};

const siteConfigCache: Record<string, IAppConfig> = {};

export const getAllSiteConfigs = async () => {
  if (!isMultiManageSite()) {
    return;
  }
  return Promise.all(
    getNeedManageSites().map(async (site) => {
      const siteDomain = getSiteDomain(site);
      const sign = md5(new URL(siteDomain).hostname);
      const res = await wrapRequestArea(() => getAppConfigApi(sign), site);
      const config = res && strToJson<IAppConfig>(res.JsonConfig);
      if (config) {
        siteConfigCache[site] = config;
      }
    })
  );
};

export const getSiteConfigs = async (site: string = '') => {
  if (!site || !isMultiManageSite()) {
    return getConfig();
  }

  if (siteConfigCache[site]) {
    return siteConfigCache[site];
  }

  const siteDomain = getSiteDomain(site);
  const sign = md5(new URL(siteDomain).hostname);
  const res = await wrapRequestArea(() => getAppConfigApi(sign), site);

  const config = res && strToJson<IAppConfig>(res.JsonConfig);
  if (config) {
    siteConfigCache[site] = config;
  }

  return config;
};
